import { useState, useEffect, FC } from 'react'
import { Auth } from '@aws-amplify/auth'

import { handleLocalStorage } from 'featureSliced/shared/hooks/handleLocalStorage'
import { Input } from 'components/Input'
import { RenderIf } from 'components/RenderIf'
import { PhoneNumberInput } from 'components/Input/PhoneNumberInput'
// import { CCProvider } from 'utils/getCCProviderIcon'
// import { TermsAndConditionsCheckbox } from 'sections/TermsConditions/checkBox'
// import { CheckBox } from 'featureSliced/entities/CheckBox'
import { Spinner } from 'featureSliced/entities/Spinner'

import list from 'assets/payment/list.svg'
import branch from 'assets/payment/branch.svg'

import { TableDiv } from 'sections/Payment/styled'
import {
  Instructions,
  Instruction_Item,
  Instruction_Text,
  Point,
  SelfService_Container,
  Steps,
  Step_Divider,
  Step_Item,
} from './styled'
import { useMySelector } from 'featureSliced/shared/hooks/useMySelector'
import { useTranslations } from 'featureSliced/shared/hooks/useTranslations'

type SelfServiceProps = {
  setIsSSButtonEnabled: (value: boolean) => void
}

export const SelfService: FC<SelfServiceProps> = ({ setIsSSButtonEnabled }) => {
  // Hooks
  const t = useTranslations()

  // Store
  const isUserAuth = useMySelector((state) => state.auth.isLoggedIn)

  // State
  const [name, setName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')

  const [isInit, setIsInit] = useState(false)

  // useEffect
  useEffect(() => {
    initUserData()
  }, [])

  useEffect(() => {
    if (name.length) {
      handleLocalStorage({ selfServiceName: name })
    }
  }, [name])

  useEffect(() => {
    if (phoneNumber.length) {
      handleLocalStorage({ selfServicePhone: phoneNumber })
    }
  }, [phoneNumber])

  useEffect(() => {
    if (isInit) {
      setIsSSButtonEnabled(Boolean(name.length && phoneNumber.length > 6))
    }
  }, [name, phoneNumber, isInit])

  // Functions
  const initUserData = async () => {
    if (isUserAuth) {
      const currentUserInfo = await Auth.currentUserInfo()
      const attributes = currentUserInfo?.attributes
      if (attributes) {
        setName(attributes.name)
        setPhoneNumber(attributes.phone_number)
      }
    }
    if (!isUserAuth) {
      const selfServiceName = handleLocalStorage('selfServiceName')
      const selfServicePhone = handleLocalStorage('selfServicePhone')
      if (selfServiceName?.length) {
        setName(selfServiceName)
      }
      if (selfServicePhone?.length) {
        setPhoneNumber(selfServicePhone)
      }
    }
    setIsInit(true)
  }

  return (
    <SelfService_Container>
      <TableDiv>{t('selfService.form')}</TableDiv>
      <RenderIf condition={process.env.REACT_APP_IS_CLIC === '0'}>
        <Steps>
          <Step_Item>
            <img src={list} alt="Products" />
          </Step_Item>
          <Step_Divider />
          <Step_Item>SMS</Step_Item>
          <Step_Divider />
          <Step_Item>
            <img src={branch} alt="Branch" />
          </Step_Item>
        </Steps>
      </RenderIf>
      <Instructions>
        <RenderIf condition={!isInit}>
          <Spinner type="alternate" />
        </RenderIf>
        <RenderIf condition={isInit}>
          <RenderIf condition={process.env.REACT_APP_IS_CLIC === '0'}>
            <Instruction_Item>
              <Point>1</Point>
              <Instruction_Text>
                {t('selfService.leaveNameText')}
              </Instruction_Text>
            </Instruction_Item>
          </RenderIf>
          <Input
            value={name}
            placeholder={t('clickCollect.nameEnter')}
            onChange={(e: any) => setName(e.currentTarget.value)}
          />
          <br />
          <PhoneNumberInput
            value={phoneNumber}
            onChange={(newValue) => setPhoneNumber(newValue)}
          />

          <RenderIf condition={process.env.REACT_APP_IS_CLIC === '0'}>
            <Instruction_Item>
              <Point>2</Point>
              <Instruction_Text>{t('selfService.receiveSMS')}</Instruction_Text>
            </Instruction_Item>
            <Instruction_Item>
              <Point>3</Point>
              <Instruction_Text>
                {t('selfService.pickUpAtStand')}
              </Instruction_Text>
            </Instruction_Item>
          </RenderIf>
        </RenderIf>
      </Instructions>
    </SelfService_Container>
  )
}
